const getBankCommission = (sum: number, bankPercent?: number | null) => {
  if (!bankPercent) {
    return 0;
  }

  return Math.round((sum * bankPercent) / 100);
};

export default getBankCommission;
